import { DoubleSide } from "three";
import { Observable } from "@legendapp/state";
import { calcBoxCenter } from "./utils";
import type { BinGroup as BinGroupType, ExtendedBin } from "./types";
import { useSelector } from "@legendapp/state/react";

export function SelectedBin({
  selected$,
}: {
  binGroups: BinGroupType[];
  selected$: Observable<ExtendedBin | null>;
}) {
  const selected = useSelector(() => selected$.get());

  if (!selected || !selected.dimensions) return null;

  return (
    <mesh
      position={calcBoxCenter(selected.x, selected.y, selected.z)}
      onClick={(e) => {
        e.stopPropagation();
        selected$.set(null);
      }}
    >
      <boxGeometry args={[...selected.dimensions]}></boxGeometry>
      <meshBasicMaterial
        color="#FFB800"
        side={DoubleSide}
        transparent
        depthTest
        depthWrite={false}
        opacity={0.5}
        polygonOffset
        polygonOffsetFactor={-4}
      />
    </mesh>
  );
}
